module.exports = __webpack_public_path__ + "img/card18.ce63221c.png";